export default {
	install(_this, options){
		_this.prototype.version = '03.03.24'
	}
}
